module.exports = __webpack_public_path__ + "img/drug_card_layout__same__fi.55c8be57.png";